<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Resultado de exame"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="8">
                    <rkm-form-input-autocomplete
                        :repository="repositories.procedimento"
                        :request-query-string-params="requestQueryStringParams"
                        :search-fields="fields"
                        :text-field="(item) => `${formatProcedimento(item.codigo)} - ${item.nome}`"
                        :validations="validations.procedimento"
                        label="Procedimento"
                        v-model="model.procedimento"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        :validations="validations.quantidade"
                        label="Quantidade"
                        number
                        v-model="model.quantidade"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="include"
                color="primary"
            >
                Incluir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import procedimento from '@/enums/sigtap/procedimento'

// Mixins.
import {error, formats, repository} from '@/mixins'

export default {
    computed: {
        requestQueryStringParams() {
            return {
                cbo_lotacao_atual: true,
                paciente_id: this.data.form.paciente.id,
                where_not: {
                    codigo: [
                        this.enums.procedimento.AVALIACAO_ANTROPOMETRICA,
                        this.enums.procedimento.GLICEMIA_CAPILAR,
                        this.enums.procedimento.MEDICAO_DE_ALTURA,
                        this.enums.procedimento.MEDICAO_DE_PESO,
                        this.enums.procedimento.AFERICAO_DE_TEMPERATURA,
                        this.enums.procedimento.AFERICAO_PRESSAO_ARTERIAL,
                    ],
                },

            }
        },
        validations() {
            return {
                procedimento: {required: true},
                quantidade: {
                    required: true,
                    min_value: 1,
                    max: 3,
                },
            }
        },
    },
    created() {
        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
        }
    },
    data: () => ({
        enums: {procedimento},
        fields: [
            {key: 'codigo', searchable: true},
            {key: 'nome', searchable: true},
        ],
        model: {
            procedimento: null,
            quantidade: 1,
        },
    }),
    methods: {
        open() {
            this.resetForm()
            this.$refs.RkmModal.show()
        },
        include() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.data.model.procedimentos.find(procedimento => procedimento.id === this.model.procedimento.id)) {
                        this.showValidationNotification('O procedimento já foi incluído.')
                        return
                    }

                    this.data.model.procedimentos.push({
                        id: this.model.procedimento.id,
                        codigo: this.model.procedimento.codigo,
                        nome: this.model.procedimento.nome,
                        hasInstrumentoRegistroRaas: !!this.model.procedimento.hasInstrumentoRegistroRaas,
                        automatico: false,
                        quantidade: this.model.quantidade,
                    })

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.procedimento = null
            this.model.quantidade = 1
        },
    },
    mixins: [error, formats, repository],
    props: {
        data: {type: Object, required: true},
    },
}
</script>